import AppInitWrapper from "./AppInitWrapper";

export default AppInitWrapper;
